import React, { useEffect, useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Button,
  Portal,
} from "@chakra-ui/react";
import profile from "../../../Assets/profile.svg";
import UserProfile from "../../../Assets/newProfile.svg";
import portfolio from "../../../Assets/lock.svg";
import question from "../../../Assets/question.svg";

import Logout from "../../../Assets/newLogout.svg";
import tc from "../../../Assets/tc.svg";
// message_question

import style from "./index.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../redux/actions";
import { studentActions } from "../../../redux/actions";
import DefaultIcon from "../../../Assets/DefaultIcon.svg";
import { getUserById } from "services/api";

const Profilepopup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const student = useSelector((state) => state.student);
  const [user, setUser] = useState("");
  const [profilePhoto, setProfilePhoto] = useState(null);

  const supportEmail = "support@ajnalens.com";

  useEffect(() => {
    const locationEndpoint = location.pathname.split("/");
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?._id;
    if (locationEndpoint[2] === "student" || user?.profile === "ajna_student") {
      const fetchStudent = async () => {
        let { data } = await getUserById(userId);
        setProfilePhoto(data?.data?.profilePhoto);
        dispatch(studentActions.setStudent(userId)).then((_) => {
          setUser("student");
        });
      };
      fetchStudent();
    }
  }, [location]);

  const handleClick = () => {
    window.location.href = `mailto:${supportEmail}`;
  };
  return (
    <Popover size={"20px"}>
      <PopoverTrigger>
        <img
          src={profilePhoto || DefaultIcon}
          alt="profile"
          onError={(e) => (e.target.src = DefaultIcon)}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent w={250}>
          <PopoverArrow />
          {/* <PopoverHeader >
              Notifications
            </PopoverHeader> */}
          {/* <PopoverCloseButton /> */}
          <PopoverBody>
            <div className={style.profileCont}>
              <div className={style.profile}>
                <div className={style.images}>
                  <img
                    src={UserProfile}
                    alt="userprofile"
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <Link to="/hiring/student/profile" reloadDocument={true}>
                  <div>View Profile</div>
                </Link>
              </div>
              <div className={style.profile}>
                <div className={style.images}>
                  <img src={portfolio} alt="portfolio" />
                </div>
                <Link to="/hiring/student/change_password">
                  <div>Change Password</div>
                </Link>
              </div>
              <div className={style.profile}>
                <div className={style.images}>
                  <img src={question} alt="question" />
                </div>
                <a
                  target="_blank"
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=support@ajnalens.com"
                >
                  Help
                </a>
              </div>
              <div className={style.profile}>
                <div className={style.images}>
                  <img src={tc} alt="t&c" />
                </div>
                <Link to="/hiring/student/t&c">
                  <div>Legal</div>
                </Link>
              </div>
              <div
                className={style.profile}
                onClick={() => dispatch(authActions.logout("student"))}
              >
                <div className={style.images}>
                  <img src={Logout} alt="Logout" />
                </div>
                <div>Logout</div>
              </div>
            </div>
          </PopoverBody>
          {/* <PopoverFooter>This is the footer</PopoverFooter> */}
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default Profilepopup;
